<template>
<div>
  <!-- <Demo v-if="!isMobile()" />
  <NotAvailableOnMobile v-else /> -->
  <Demo />
</div>
</template>

<script>
import Demo from "@/components/demos/Demo.vue";
import { isMobileMixin } from '@/mixins/isMobileMixin';
import NotAvailableOnMobile from "@/components/misc/NotAvailableOnMobile.vue";

export default {
  name: "DemoReviewPage",
  components: { Demo, NotAvailableOnMobile },
  mixins: [isMobileMixin],
  metaInfo: {
    title: "Demo Review",
  },
};
</script>
